/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Prudhvi Garapati",
  logo_name: "Prudhvi Garapati",
  nickname: "prudhvi_gnv",
  subTitle:
    "A passionate computer science student  who loves technology and wants to work in cutting edge technologies. I am passionate about building end-to-end products. I'm a ideas guy and a people's person which helps me to think out of the box and able to make things done. ",

  resumeLink: "prudhvi resume.pdf",
  portfolio_repository: "https://github.com/PrudhviGNV",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/PrudhviGNV",
  linkedin: "https://www.linkedin.com/in/prudhvignv/",
  gmail: "prudhvi.gnv@gmail.com",

  facebook: "https://www.facebook.com/prudhvi.gnv/",

  instagram: "https://www.instagram.com/prudhvi_gnv/",
  stackoverflow: "https://stackoverflow.com/users/12230470/prudhvi-gnv",
  medium: "https://medium.com/@prudhvi.gnv",
};

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Done various machine learning and deep learning projects",
        "⚡ Knowledge on Data visualization and data preprocessing",
        "⚡ Able to build the ML model in production mode",
        "⚡ Experience of working with Computer Vision and NLP projects",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },

        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },

        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "pandas",
          fontAwesomeClassname: "simple-icons:pandas",
        },
        {
          skillName: "Machine learning",
          fontAwesomeClassname: "simple-icons:datacamp",
        },

        {
          skillName: "numpy",
          fontAwesomeClassname: "simple-icons:numpy",
        },
        {
          skillName: "matplotlib",
          fontAwesomeClassname: "simple-icons:mathplotlib",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using React",
        "⚡ Developing mobile friendly web applications using Bootstrap",
        "⚡ Knowledge in creating application backend in Flask",
        "⚡ Able to implement common tasks using JQuery",
        "⚡ Idea on various technology stack for web development ",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },

        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "simple-icons:mysql",
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
        },
        {
          skillName: "JQuery",
          fontAwesomeClassname: "simple-icons:jquery",
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on AWS components such as EC2, S3",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying deep learning models on cloud for production",
        "⚡ knowledge on various cloud concepts and services",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },

        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
    {
      title: "Tools & Technologies",
      fileName: "DesignImg",
      skills: [
        "⚡ Languages : Python, Java, JavaScript, C, C#, HTML5, CSS3",
        "⚡ Git, Github",
        "⚡ MySQL ",
        "⚡ Notebooks ( Google colabs, kaggle, jupyter )",

        "⚡ Visual studio, Anaconda, Pycharm",
        "⚡ Machine learning , Data Science, Web development",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
        },
        {
          skillName: "java",
          fontAwesomeClassname: "simple-icons:java",
        },
        {
          skillName: "javascript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            color: "#f0e141",
          },
        },
        {
          skillName: "c",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#384ccf",
          },
        },
        {
          skillName: "c #",
          fontAwesomeClassname: "simple-icons:csharp",
        },

        {
          skillName: "visual studio",
          fontAwesomeClassname: "simple-icons:visualstudio",
          style: {
            color: "#41bef0",
          },
        },
        {
          skillName: "GITHUB",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#0d0c0c",
          },
        },
        {
          skillName: "git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#f24141",
          },
        },
        {
          skillName: "Anaconda",
          fontAwesomeClassname: "simple-icons:anaconda",
          style: {
            color: "#3de03d",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#41bef0",
          },
        },

        {
          skillName: "geekforgeeks",
          fontAwesomeClassname: "simple-icons:geeksforgeeks",
          style: {
            color: "#3de03d",
          },
        },
        {
          skillName: "ms office",
          fontAwesomeClassname: "simple-icons:microsoftoffice",
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/prudhvi_gnv",
    },
    {
      siteName: "Medium",
      iconifyClassname: "simple-icons:medium",
      style: {
        color: "#141414",
      },
      profileLink: "https://medium.com/@prudhvi.gnv",
    },
    {
      siteName: "Acclaim",
      iconifyClassname: "simple-icons:adobe",
      style: {
        color: "#0c6575",
      },
      profileLink:
        "https://www.youracclaim.com/users/naga-venkata-prudhvi-garapati/badges",
    },
    {
      siteName: "stackoverflow",
      iconifyClassname: "simple-icons:stackoverflow",
      style: {
        color: "#d11d1d",
      },
      profileLink: "https://stackoverflow.com/users/12230470/prudhvi-gnv",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/prudhvignv",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Gudlavalleru Engineering College, Andhra Pradesh",
      subtitle: "B.Tech. in Computer Science",
      logo_path: "gec.png",
      alt_name: "GEC ",
      duration: "2017 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done certification courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",

        "⚡ Also done various projects for hands on experience and to make myself ready.",
      ],
      website_link: "https://gecgudlavalleru.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Google IT support ",
      subtitle: "  - professional certification",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/professional-cert/D6FVPDW5QNWX",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/FFD8SWPGSLMB",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/NYBYWCAVG5G8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },

    {
      title: "Full Stack developer",
      subtitle: "- Freecodecamp",
      logo_path: "fcc.jpg",
      certificate_link:
        "https://www.freecodecamp.org/certification/prudhvi_gnv/responsive-web-design",
      alt_name: "freecodecamp",
      color_code: "#00000099",
    },
    {
      title: "Python Data Structures",
      subtitle: "- University of Michigan",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/UQEGRWJF4L39",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Big Data & ML on GCP",
      subtitle: "- GCP",
      logo_path: "gcp_logo.png",
      certificate_link:
        "hhttps://www.coursera.org/account/accomplishments/certificate/MFMQKPW3DGFP",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "DevOps mindset and culture",
      subtitle: "- University of California",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/6Y5L79GQFJCR",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Java",
      subtitle: "- IIT Kharagpur",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://nptel.ac.in/noc/Ecertificate/?q=noc19-cs07/NPTEL19CS07S61360046191203622.jpg",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: " Digital Marketing",
      subtitle: "- GoogleDigitalGarage",
      logo_path: "google_logo.png",
      certificate_link:
        "https://learndigital.withgoogle.com/digitalgarage/validate-certificate-code",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many technologies and concepts such as machine learning , data science , cloud computing, web development. I love building things.  I am a people's person and a tech guy who always try to help others to grow them and to grow myself. I also aquainted with design, develop , deployment pipeline which makes me a full stack developer.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Py-AutoML",
          company: "Published a  python package at pypi ",
          company_url: "https://pypi.org/project/py-automl/",
          logo_path: "pypi1.jpg",

          location: "Pypi",
          description: [
            "⚡ Py-AutoML is a minimalistic low code machine learning library in python                       |.",
            "⚡ I have developed this package  for my pet project for quick and easy development of ml models. here we can implement machine learning models with fewer lines of code.",
            "⚡ Extremely useful for small scale projects and acts as a wrapper which simplifies our coding task ",
            "⚡  Can define and implement popular neural network such as AlexNet, GoogleNet, LeNet5, VGG16, Deep CNN with ease.",
            "⚡ Easily visualize neural network in a single line of code",
            "⚡ Check out:   pip install py-automl ",
          ],
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Machine learning intern",
          company: "SmartBridge",
          company_url: "smartinternz.com",
          logo_path: "smartbridge.png",
          duration: "April 2020 - July 2020",
          location: "Remote intership",
          description:
            "⚡ I have worked on various project to get aquainted and skillup my knowledge in machine learning domain. There were two objectives: (1) Preprocessing the data and make data to tell a story . (2)Knowing machine learning concepts and the mathematics behind scenes. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Tech Writer",
          company: "Medium",
          company_url: "www.medium.com",
          logo_path: "medium.png",
          duration: "June 2019 - present",
          location: "Blogging",
          description:
            "⚡ Write technical content based on my knowledge. I believe - the best way to learn something is to teach someone. I write blogs on data science , machine learning , computer science and on some of my projects and certifications based on my intuition-based learning . ⚡ link: www.medium.com/@prudhvi.gnv",
          color: "#4285F4",
        },

        {
          title: "Student Mentor",
          company: "GEC",
          company_url: "www.gecgudlavalleru.ac.in",
          logo_path: "gec.png",
          duration: "Jan 2018 - jan 2019",
          location: "GEC, Andhra Pradesh",
          description:
            "I personally mentored 5 students over the course one year. It's really fun and a great learning curve to help and teach someone .",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "⚡ I am actively contributing to opensource communities. I also  opensource my projects in github. In future, I want to  contribute to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Keras etc. These contributions include bug fixes, feature requests and formulating peoper documentation for project. ⚡ link: www.github.com/PrudhviGNV",
          color: "#181717",
        },
      ],
    },
  ],
};

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "prudhvi.png",
    description:
      "DISCUSS A PROJECT OR JUST WANT TO SAY HI? MY INBOX IS OPEN FOR ALL ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I write blogs on technical content on various technology trends , technologies and on my projects ",
    link: "https://www.medium.com/@prudhvi.gnv",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Neelamahal road, Gudivada 521301",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/@/data=!4m5!7m4!1m2!1s106936778646362072625!2sChZEQkhVaWpTNVgzaVZ3SjB1RXF3NVl3EggHBa5mVrr1tg%3D%3D!2e2?hl=en",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 7989010088",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  blogSection,
  contactPageData,
};
